import React from 'react';

export default function GlobalCompliancePolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">

        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">
          Global Compliance Policy
        </h1>

        <p className="text-gray-700 mb-8">
          Million2Trillion (M2T) operates across multiple global markets, and maintains strict compliance with international financial, tax, and data protection regulations to protect all verified participants.
        </p>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Regulatory Oversight</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>M2T does not act as a broker-dealer, asset manager, or licensed financial institution.</li>
          <li>All trading, investment, advisory, and educational services are provided by verified professionals under their own local regulations.</li>
          <li>M2T requires independent legal, tax, and financial compliance certifications from professionals offering regulated services.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">International Tax Compliance</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>All payout receivers and monetized users must submit proper tax documents and declarations based on local jurisdiction.</li>
          <li>M2T reports necessary platform earnings data to tax authorities upon lawful request or regulatory mandate.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">Data Protection Standards</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>GDPR (European Union General Data Protection Regulation)</li>
          <li>CCPA (California Consumer Privacy Act)</li>
          <li>UAE Data Protection Law (where applicable)</li>
          <li>Other international data privacy regulations followed based on customer location.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-blue-900 mt-8 mb-2">AML (Anti-Money Laundering)</h2>
        <ul className="list-disc text-gray-700 space-y-3 pl-6 mb-6">
          <li>Full identity verification required for all financial accounts receiving platform earnings.</li>
          <li>Transaction monitoring performed to detect any suspicious fund movement.</li>
          <li>Full cooperation provided to global authorities investigating financial crimes or sanctions violations.</li>
        </ul>

        <p className="text-gray-500 italic mt-10">
          Verified market systems require verified global compliance. M2T aligns with both platform and user compliance duties as a trusted global financial marketplace.
        </p>
      </div>
    </div>
  );
}
